/* ── Admin Channel Manager (ES Module) ── */
import { catalog, selectedChannel, updateState, templates } from '../admin-globals.js';
import { showToast, showConfirm } from '../admin-ui-base.js';
import { authHeaders } from '../admin-auth.js';
import { canEditChannel, renderMain, renderSidebar } from '../catalog-ui.js';
import { fetchMissingDurations } from '../duration-service.js';

let _importedVideos = null;

export function updateChannelField(field, value) {
  if (selectedChannel === null || !catalog[selectedChannel]) return;
  const ch = catalog[selectedChannel];
  if (!canEditChannel(ch)) {
    showToast('CANAL EN SOLO LECTURA', true);
    renderMain();
    return;
  }
  catalog[selectedChannel][field] = value;
  if (field === 'sync' && value === true) {
    // Duraciones + guardar canal (sync y vídeos persisten juntos)
    if (window.fetchMissingDurations) void window.fetchMissingDurations(true);
  }
}

export function openAddChannel() {
  _importedVideos = null;
  document.getElementById('ch-modal-title').textContent = 'NUEVO CANAL';
  document.getElementById('ch-num').value = String(catalog.length + 1).padStart(2, '0');
  document.getElementById('ch-name').value = '';
  document.getElementById('ch-color').value = '#00FFFF';
  document.getElementById('ch-sync').checked = false;
  
  const templateSelect = document.getElementById('ch-template');
  if (templateSelect) {
    if (templates.length > 0) {
      templateSelect.innerHTML = templates.map(t => `<option value="${t}">${t}</option>`).join('');
      templateSelect.value = templates[0];
    } else {
      templateSelect.innerHTML = '<option value="RapTV">RapTV (Classic)</option>';
      templateSelect.value = 'RapTV';
    }
  }
  
  const backgroundInput = document.getElementById('ch-background');
  if (backgroundInput) backgroundInput.value = '';
  
  document.getElementById('ch-json-filename').textContent = '';
  document.getElementById('ch-json-input').value = '';
  document.getElementById('channel-modal').classList.remove('hidden');
}

export function closeChannelModal() {
  document.getElementById('channel-modal').classList.add('hidden');
  _importedVideos = null;
}

export function importChannelJson(input) {
  const file = input.files[0];
  if (!file) return;
  const reader = new FileReader();
  reader.onload = function(e) {
    try {
      const data = JSON.parse(e.target.result);
      if (data.num) document.getElementById('ch-num').value = data.num;
      if (data.name) document.getElementById('ch-name').value = data.name;
      if (data.color) document.getElementById('ch-color').value = data.color;
      if (data.sync !== undefined) document.getElementById('ch-sync').checked = !!data.sync;
      if (data.template) document.getElementById('ch-template').value = data.template;
      if (data.background) document.getElementById('ch-background').value = data.background;
      _importedVideos = Array.isArray(data.videos) ? data.videos : [];
      document.getElementById('ch-json-filename').textContent = file.name + ' (' + _importedVideos.length + ' vídeos)';
    } catch(err) {
      showToast('JSON INVÁLIDO', true);
      document.getElementById('ch-json-filename').textContent = '';
      _importedVideos = null;
    }
  };
  reader.readAsText(file);
}

export async function deleteChannel(e, index) {
  if (e) e.stopPropagation();
  showConfirm(
    `¿Eliminar CH ${catalog[index].num} ${catalog[index].name}? Esta acción no se puede deshacer.`,
    () => _doDeleteChannel(index),
    '¿ELIMINAR CANAL?'
  );
}

async function _doDeleteChannel(index) {
  const ch = catalog[index];
  try {
    const res = await fetch(`/channels/${ch.id}`, { method: 'DELETE', headers: authHeaders() });
    if (!res.ok) throw new Error(await res.text());
  } catch(err) {
    showToast('ERROR AL ELIMINAR CANAL', true);
    console.error(err);
    return;
  }
  catalog.splice(index, 1);
  if (selectedChannel >= catalog.length) updateState('selectedChannel', catalog.length - 1);
  if (catalog.length === 0) updateState('selectedChannel', null);
  renderSidebar();
  renderMain();
  showToast('CANAL ELIMINADO');
}

export async function saveChannel() {
  const num = document.getElementById('ch-num').value.trim();
  const name = document.getElementById('ch-name').value.trim();
  const color = document.getElementById('ch-color').value;
  const sync = document.getElementById('ch-sync').checked;
  const template = document.getElementById('ch-template').value;
  const background = document.getElementById('ch-background').value.trim();

  if (!num || !name) { showToast('FALTAN DATOS', true); return; }

  const newCh = {
    num,
    name,
    color,
    sync,
    template,
    background,
    videos: _importedVideos || []
  };

  showToast('CREANDO CANAL...');
  try {
    const res = await fetch('/channels', {
      method: 'POST',
      headers: { ...authHeaders(), 'Content-Type': 'application/json' },
      body: JSON.stringify(newCh)
    });
    if (!res.ok) throw new Error(await res.text());
    const saved = await res.json();
    catalog.push(saved);
    updateState('selectedChannel', catalog.length - 1);
    closeChannelModal();
    renderSidebar();
    renderMain();
    showToast('CANAL CREADO');
  } catch(err) {
    showToast('ERROR AL GUARDAR CANAL', true);
    console.error(err);
  }
}